import { render, staticRenderFns } from "./imports_select_submissions_table.vue?vue&type=template&id=4339f204&scoped=true&"
import script from "./imports_select_submissions_table.vue?vue&type=script&lang=js&"
export * from "./imports_select_submissions_table.vue?vue&type=script&lang=js&"
import style0 from "./imports_select_submissions_table.vue?vue&type=style&index=0&id=4339f204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4339f204",
  null
  
)

export default component.exports